/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BorPscReportResponse as ReportsBorPscReportResponse } from '../../models/reports/bor-psc-report-response';

export interface ApiV1BorCompaniesCompanyIdPscReportJsonGet$Params {

/**
 * Company ID
 */
  companyId: number;
}

export function apiV1BorCompaniesCompanyIdPscReportJsonGet(http: HttpClient, rootUrl: string, params: ApiV1BorCompaniesCompanyIdPscReportJsonGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportsBorPscReportResponse>> {
  const rb = new RequestBuilder(rootUrl, apiV1BorCompaniesCompanyIdPscReportJsonGet.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportsBorPscReportResponse>;
    })
  );
}

apiV1BorCompaniesCompanyIdPscReportJsonGet.PATH = '/api/v1/bor/companies/{companyId}/psc/report.json';
